module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray-cc054fb6ba2c7bd92f75db00a512e51b.png";